import { render, staticRenderFns } from "./panel-pay.vue?vue&type=template&id=e0fd3e22&scoped=true&"
import script from "./panel-pay.vue?vue&type=script&lang=js&"
export * from "./panel-pay.vue?vue&type=script&lang=js&"
import style0 from "./panel-pay.vue?vue&type=style&index=0&id=e0fd3e22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0fd3e22",
  null
  
)

export default component.exports